<template>
    <div class="home-container">
        <nav
            class="navbar navbar-transparent navbar-color-on-scroll fixed-top navbar-expand-lg p-0"
            color-on-scroll="100"
            id="sectionsNav">
            <div class="container-fluid">
                <div class="navbar-translate">
                    <router-link to="/" class="ml-md-5">
                        <img
                            src="../../public/assets/img/acceleration_logo.png"
                            class="img-fluid ml-md-5 mt-3"
                            style="width:100px"
                            alt
                        />
                        <!--<div class="text-orange text-center">-->
                        <!--<b>Employability Portal</b>-->
                        <!--</div>-->
                    </router-link>
                    <!--<button-->
                    <!--class="navbar-toggler"-->
                    <!--type="button"-->
                    <!--data-toggle="collapse"-->
                    <!--aria-expanded="false"-->
                    <!--aria-label="Toggle navigation"-->
                    <!--&gt;-->
                    <!--<span class="sr-only">Toggle navigation</span>-->
                    <!--<span class="navbar-toggler-icon"></span>-->
                    <!--<span class="navbar-toggler-icon"></span>-->
                    <!--<span class="navbar-toggler-icon"></span>-->
                    <!--</button>-->
                </div>
                <!--<div class="collapse navbar-collapse">-->
                <!--<ul class="navbar-nav ml-auto">-->
                <!--<li class="nav-item">-->
                <!--<router-link class="nav-link" to="/internship">Internship</router-link>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                <!--<router-link class="nav-link" to="/events">Events</router-link>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                <!--<router-link class="nav-link" to="/scholarship">Scholarship</router-link>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                <!--<router-link class="nav-link" to="/talent">Talent</router-link>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                <!--<router-link class="nav-link" to="/career">Career Tips & Research</router-link>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                <!--<router-link class="nav-link cursor-pointer" to="/news">-->
                <!--News-->
                <!--</router-link>-->
                <!--</li>-->
                <!--&lt;!&ndash; <li class="nav-item">-->
                <!--<a class="nav-link" href="javascript:void(0)">Job & Skills Resource Portal</a>-->
                <!--</li> &ndash;&gt;-->
                <!--</ul>-->
                <!--<ul class="navbar-nav pt-2" v-if="!$store.getters.loggedIn">-->
                <!--<li class="p-2">-->
                <!--<router-link class="nav-link btn btn-orange" to="/login">Login</router-link>-->
                <!--</li>-->
                <!--</ul>-->
                <!--</div>-->
            </div>
        </nav>
        <div class="d-flex justify-content-center" id="contentItem">
            <div class="container-fluid custom-container-fluid ml-md-5 home_item text-light">
                <div class="row">
                    <div class="col-md-7">
                        <h1 class="font-weight-bold heading">GTL National Acceleration <br> Program</h1>
                        <div class="mt-3">
                            Are you a tech-oriented startup or a startup with a tech-enabled product?
                            Join our 5-month National Acceleration Program and receive:
                        </div>
                        <ol class="ml-3 mb-4 mt-3">
                            <li>
                                Access to free tailored business development support.
                            </li>
                            <li>
                                Access to expert advisory service.
                            </li>
                            <li>
                                Access to Mentorship.
                            </li>
                            <li>
                                Access to Program activity grant support.
                            </li>
                            <li>
                                Access to Market.
                            </li>

                            <li>Access to Debt and Equity Investment.</li>

                        </ol>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-8 offset-2">
                                <div class="dropdown">
                                    <router-link to="/national-acceleration-program/apply" class="btn btn-orange btn-block custom-button">Apply
                                    </router-link>
                                </div>
                            </div>
                            <!--<div class="col-6">-->
                                <!--<a href="../../assets/img/Call-for-Startups-for-GTL-National-Acceleration-Program.pdf" target="_blank" class="btn btn-outline-orange btn-block custom-button">Learn More</a>-->
                            <!--</div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import Navbar from "../components/Navbar";
    export default {
        name: "Home",
        data() {
            return {
                isLoading: false,
                fullPage: true,
                height: 128,
                width: 128,
                userInfo: this.$store.state.userInfo,
            };
        },
        created() {
            document.title = 'National Acceleration Program'
        },

        methods: {}
    };
</script>

<style scoped>
    /* navbar */
    .navbar.navbar-transparent {
        background: linear-gradient(91.31deg, #021D1F 31.18%, #021D1F 41.67%, #ffffff00 47.63%), linear-gradient(92.53deg, #021D1F 31%, rgba(255, 255, 255, 0) 51.72%) !important;
    }

    .nav-item a {
        color: black !important;
        font-family: var(--gotham);
        font-size: 17px !important;
        text-transform: none !important;
    }

    .dropdown-menu {
        min-width: 15.5rem;
        border-radius: 15px;
        padding: 0px !important;
    }

    .dropdown-item:hover {
        background: #f26526f5;
        box-shadow: none;
    }

    .dropdown-menu .dropdown-item {
        margin: 0px !important;
    }

    .dropdown-menu .dropdown-item:nth-child(1) {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
    }

    .dropdown-menu .dropdown-item:nth-child(2) {
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
    }

    .dropdown-menu[x-placement='bottom-start'] {
        top: 62px !important;
    }

    .dropdown-menu[x-placement='top-start'] {
        top: -95px !important;
    }

    /* home styling */
    .home-container {
        height: 100vh;
        background: linear-gradient(79.4deg, #021D1F 27.5%, rgba(2, 29, 31, 0.2) 92.73%), url("../assets/home_bg_2.jpg");
        background-size: cover;
    }

    .navbar {
        box-shadow: none !important;
    }

    .home_item {
        margin-top: 15rem;
    }

    .custom-button {
        padding: 1rem 0px;
        border-radius: 15px;
        font-size: 15px
    }

    @media screen and (min-width: 1263px) {
        .h1 {
            font-size: 7rem !important;
        }
    }
    @media screen and (max-width: 996px) {
        .heading{
            font-size: 30px;
        }
    }

    #contentItem {
        position: relative;
        left: 50%;
        top: 35%;
        transform: translate(-50%, -50%);
    }
</style>
